import { useEffect, useState } from "react"
import { Box, CircularProgress } from "@mui/material"
import Typography from "@mui/material/Typography"
import CloseIcon from "@mui/icons-material/Close"
import { MenuItem, OutlinedInput, Select } from "@mui/material"

import Modal from "@mui/material/Modal"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
  OpportunityModalHeader,
  OpportunityDetailsWrapper,
  OpportunityDetailsSubWrapper,
  OpportunityMerticName,
  OpportunityOfficeName,
  OpportunityFields,
  OpportunityMerticField,
  OpportunityMerticFieldOne,
  OpportunityMerticFieldTwo,
  OpportunityMerticDate,
  OpportunityMerticStartDateOne,
  OpportunityMerticEndDateTwo,
  OpportunityButtons,
  ButtonWrapper,
  CancelButton,
  SetButton,
  MenuProps,
} from "./Atom"
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo"
import dayjs, { Dayjs } from "dayjs"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { getTokenLocal } from "../../../../helper/utils"
import MetricAPI from "../../../../api/metric"
import { toast } from "react-toastify"
import { useDispatch, useSelector } from "react-redux"
import {
  setMetricOpportunityActiveRow,
  setMetricOpportunityModalOpen,
  setSelectedMetricOpportunityTab,
} from "../../../redux/slices/metricSlice"
import moment from "moment"
import { colors } from "../../../../styles/commonStyles"
import { useResponseHandle } from "../../../hooks"
import { setProntoAiStoreData } from "../../../redux/slices/prontoAiSlice"

const metricAPI = new MetricAPI()

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  height: 520,
  bgcolor: "background.paper",
  boxShadow: "0px 3px 6px #00000029",
  borderRadius: "5px",
}

type AiCreateOpportunityModalProps = {
  handleFetchProntoAiTableData: any
}
const AiCreateOpportunityModal = (props: AiCreateOpportunityModalProps) => {
  const { handleFetchProntoAiTableData } = props

  const [selectedOption, setSelectedOption] = useState("")
  const [currentMetricValue, setCurrentmetricValue] = useState("")
  const [currentMetricValueColor, setcurrentMetricValueColor] = useState("")
  const [currentValueDataType, setCurrentValueDataType] = useState("")
  const [columnId, setColumnId] = useState("")
  const [selectedAdvisor, setSelectedAdvisor] = useState(null)

  // const today = new Date()
  const today: any = moment()
  const tomorrow: any = moment().add(1, "days")
  const fullDate = new Intl.DateTimeFormat("en-us", {
    dateStyle: "short",
  })
  const [endDate, setEndDate] = useState<any>(
    moment(tomorrow).format("YYYY-MM-DD"),
  )

  const token: any = getTokenLocal()

  const open = useSelector((state: any) => {
    return state.metric.metricOpportunityModalOpen
  })
  const storeData = useSelector((state: any) => {
    return state.prontoAi.prontoAiStoreData
  })
  const selectedMetric = useSelector((state: any) => {
    return state.prontoAi.selectedMetric
  })

  const opportunityAdvisorList = useSelector((state: any) => {
    return state.metric.opportunityAdvisorList
  })

  const dispatch = useDispatch()

  const isDisabled: boolean = !(
    selectedOption ||
    currentMetricValue ||
    currentMetricValueColor ||
    currentValueDataType ||
    columnId ||
    selectedAdvisor
  )

  const handleClose = () => {
    setSelectedOption("")
    setCurrentmetricValue("")
    setcurrentMetricValueColor("")
    setCurrentValueDataType("")
    setColumnId("")
    setSelectedAdvisor(null)
    dispatch(setMetricOpportunityActiveRow(null))
    dispatch(setMetricOpportunityModalOpen(false))
    dispatch(setProntoAiStoreData([]))
  }

  const setOpportunity = async () => {
    if (!selectedAdvisor) {
      toast.error("Please select an advisor")
      return
    }

    if (token) {
      const data = {
        group_sk: selectedMetric?.group_sk,
        region: selectedMetric?.region,
        practice_sk: selectedMetric?.practice_sk,
        metric_id: selectedMetric?.metric_id,
        metric_store_id: selectedMetric?.metric_store_id,
        target_column_id: columnId,
        target_column_value:
          currentValueDataType == "%"
            ? JSON.stringify(parseFloat(currentMetricValue) / 100)
            : currentMetricValue,
        target_column_value_highlighting: currentMetricValueColor,
        end_date: endDate,
        advisor_id: selectedAdvisor,
      }

      const response = await metricAPI.setOpportunityData(token, data)

      const result = useResponseHandle({
        apiResponse: response,
        successMessage: false,
      })

      if (result?.isAuthorized) {
        if (result?.statusCode == 200) {
          handleFetchProntoAiTableData()
          handleClose()
        }
      }
    }
  }
  const headersToCapsLock = ["Cytd", "Py", "pytd", "ttm"]

  const capitalizeMatchingWord = (sentence: string) => {
    // Split the sentence into words
    const words = sentence.split(/\s+/)
    // Iterate over each word in the sentence
    const capitalizedWords = words.map((word) => {
      // Check if the word exists in the headersToCapsLock array
      const matchIndex = headersToCapsLock.findIndex(
        (header) => header.toLowerCase() === word.toLowerCase(),
      )

      // If the word exists in headersToCapsLock, capitalize it
      if (matchIndex !== -1) {
        return word.toUpperCase()
      }

      // Otherwise, return the word as is
      return word
    })
    // Join the words back into a sentence
    return capitalizedWords.join(" ")
  }

  return (
    <Modal
      open={open}
      onClose={() => handleClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <OpportunityModalHeader>
          <Typography
            onClick={() => {
              //console.log("row", row?.original)
            }}
          >
            Set Active Opportunity
          </Typography>
          <CloseIcon sx={{ cursor: "pointer" }} onClick={() => handleClose()} />
        </OpportunityModalHeader>
        {storeData?.length ? (
          <OpportunityDetailsWrapper>
            <OpportunityDetailsSubWrapper>
              <OpportunityMerticName>
                {selectedMetric?.Metric}
              </OpportunityMerticName>

              <OpportunityOfficeName>
                {selectedMetric?.practice_name}
              </OpportunityOfficeName>

              <OpportunityFields>
                <OpportunityMerticField>
                  <OpportunityMerticFieldOne>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#000000",
                        paddingBottom: "7px",
                      }}
                    >
                      Select a Metric KPI
                    </Typography>

                    <Select
                      sx={{ width: "100%", textTransform: "capitalize" }}
                      IconComponent={ExpandMoreIcon}
                      value={selectedOption}
                      onChange={(e: any) => setSelectedOption(e.target.value)}
                      MenuProps={MenuProps}
                    >
                      {storeData?.map((option: any, index: any) => (
                        <MenuItem
                          key={index}
                          value={option?.column_name}
                          onClick={() => {
                            setCurrentmetricValue(
                              // option?.column_datatype == "%"
                              //   ? JSON.stringify(
                              //       parseFloat(option?.column_value) / 100,
                              //     )
                              // :
                              option?.column_value,
                            )
                            setcurrentMetricValueColor(option?.column_color)
                            setColumnId(option?.column_id)
                            setCurrentValueDataType(option?.column_datatype)
                          }}
                          sx={{ textTransform: "capitalize" }}
                        >
                          {capitalizeMatchingWord(option.column_name)}
                        </MenuItem>
                      ))}
                    </Select>
                  </OpportunityMerticFieldOne>

                  <OpportunityMerticFieldTwo>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#000000",
                        paddingBottom: "7px",
                      }}
                    >
                      Current Metric Value
                    </Typography>
                    <OutlinedInput
                      id="outlined-adornment-weight"
                      aria-describedby="outlined-weight-helper-text"
                      inputProps={{
                        "aria-label": "weight",
                      }}
                      sx={{
                        width: "100%",
                        backgroundColor:
                          currentMetricValueColor === "red"
                            ? colors.primaryRed
                            : currentMetricValueColor === "green"
                            ? colors.primaryGreen
                            : currentMetricValueColor === "yellow"
                            ? colors.primaryYellow
                            : "",
                        color:
                          currentMetricValueColor === "red"
                            ? colors.primaryWhite
                            : currentMetricValueColor === "green"
                            ? colors.primaryWhite
                            : currentMetricValueColor === "yellow"
                            ? colors.primaryBlack
                            : "",
                      }}
                      value={
                        currentMetricValue === null
                          ? ""
                          : currentMetricValue.trim() === ""
                          ? ""
                          : currentValueDataType == "%"
                          ? `${parseFloat(
                              currentMetricValue,
                            ).toLocaleString()} ${currentValueDataType}`
                          : `${currentValueDataType} ${parseFloat(
                              currentMetricValue,
                            ).toLocaleString()}`
                      }
                    />
                  </OpportunityMerticFieldTwo>
                </OpportunityMerticField>

                <OpportunityMerticDate>
                  <OpportunityMerticStartDateOne>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#000000",
                        paddingBottom: "7px",
                      }}
                    >
                      Start Date
                    </Typography>
                    <OutlinedInput
                      id="outlined-adornment-weight"
                      aria-describedby="outlined-weight-helper-text"
                      inputProps={{
                        "aria-label": "weight",
                      }}
                      sx={{ width: "100%", marginTop: "1px" }}
                      value={moment(today).format("MM/DD/YYYY")}
                      disabled
                    />
                  </OpportunityMerticStartDateOne>
                  <OpportunityMerticEndDateTwo>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#000000",
                        paddingBottom: "0px",
                      }}
                    >
                      End Date
                    </Typography>

                    {/* <OutlinedInput
                    id="outlined-adornment-weight"
                    aria-describedby="outlined-weight-helper-text"
                    inputProps={{
                      "aria-label": "weight",
                    }}
                    value={fullDate?.format(today)}
                    sx={{ width: "100%" }}
                  /> */}

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        components={["DatePicker"]}
                        sx={{
                          "& .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input":
                            {
                              padding: "16.3px 14px",
                            },
                          "& .css-1tofg7p-MuiStack-root": {
                            padding: "0px",
                          },
                          "& .css-13bvbr1-MuiStack-root": {
                            width: "100%",
                          },
                        }}
                      >
                        <DemoItem>
                          <DatePicker
                            minDate={dayjs(tomorrow)}
                            defaultValue={dayjs(tomorrow)}
                            onChange={(newValue: any) =>
                              setEndDate(dayjs(newValue).format("YYYY-MM-DD"))
                            }
                          />
                        </DemoItem>
                      </DemoContainer>
                    </LocalizationProvider>
                  </OpportunityMerticEndDateTwo>
                </OpportunityMerticDate>

                <OpportunityMerticField>
                  <OpportunityMerticFieldOne sx={{ marginRight: "0" }}>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#000000",
                        paddingBottom: "7px",
                      }}
                    >
                      Choose an Advisor
                    </Typography>

                    <Select
                      sx={{
                        width: "100%",
                        textTransform: "capitalize",
                      }}
                      IconComponent={ExpandMoreIcon}
                      value={selectedAdvisor}
                      onChange={(e: any) => setSelectedAdvisor(e.target.value)}
                      MenuProps={MenuProps}
                    >
                      {opportunityAdvisorList
                        .filter((option: any) => option.uid !== "all")
                        .map((option: any, index: any) => (
                          <MenuItem
                            key={index}
                            value={option.uid}
                            sx={{ textTransform: "capitalize" }}
                          >
                            {option.label}
                          </MenuItem>
                        ))}
                    </Select>
                  </OpportunityMerticFieldOne>
                </OpportunityMerticField>
              </OpportunityFields>
            </OpportunityDetailsSubWrapper>
          </OpportunityDetailsWrapper>
        ) : (
          <Box
            sx={{
              // border: "1px solid red",
              height: "80%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography>
              <CircularProgress />
            </Typography>
          </Box>
        )}

        <OpportunityButtons>
          <ButtonWrapper>
            <CancelButton
              onClick={() => dispatch(setMetricOpportunityModalOpen(false))}
            >
              cancel
            </CancelButton>
            <Box>
              <SetButton
                onClick={() => {
                  setOpportunity()
                }}
                disabled={isDisabled}
              >
                Set
              </SetButton>
            </Box>
          </ButtonWrapper>
        </OpportunityButtons>
      </Box>
    </Modal>
  )
}

export default AiCreateOpportunityModal
